import React from "react";
import { Link } from "react-router-dom";
import { prefetchRoute } from "@/lib/prefetch";

const EXTERNAL = /^(https?:|tel:|mailto:|#)/i;

/** Lien interne via React Router (aucun rechargement), lien externe/tel/mail inchangé. */
export default function SmartLink({ href = "", children, ...rest }) {
  if (!href || EXTERNAL.test(href) || rest.target === "_blank" || rest.download) {
    return <a href={href} {...rest}>{children}</a>;
  }
  const [pathname, hash] = href.split("#");
  const warm = () => prefetchRoute(pathname || "/");
  return (
    <Link
      to={{ pathname: pathname || "/", hash: hash ? `#${hash}` : "" }}
      {...rest}
      onMouseEnter={(e) => { warm(); rest.onMouseEnter?.(e); }}
      onFocus={(e) => { warm(); rest.onFocus?.(e); }}
      onTouchStart={(e) => { warm(); rest.onTouchStart?.(e); }}
    >
      {children}
    </Link>
  );
}
